import { schema } from 'normalizr';

export const errorSchema = new schema.Entity('errors', {}, { idAttribute: 'UnHandledExceptionId' });

export const errorListSchema = [errorSchema];
